import clsx from 'clsx';
import { useTooltipStyles } from '../ChartTooltipStyles';
import { chartDefFormatter } from '../Formatters';

export const MainMetric = ({ timeslice, mainMetric }) => {
    const classes = useTooltipStyles();
    let responseItem;
    timeslice.items.forEach((item) => {
        const key = item.def?.key;
        if (key === mainMetric) responseItem = item;
    });
    return responseItem ? (
        <tr className={classes.tooltipPoint}>
            <td className={classes.borderLineTop}>
                <div className={classes.tooltipPointColorBox} style={{ backgroundColor: responseItem.def.color }} />
            </td>
            <td className={clsx(classes.tooltipPointLabel, classes.borderLineTop)}>{responseItem.def.label}:</td>
            <td className={clsx(classes.tooltipPointValue, classes.borderLineTop)}>
                {chartDefFormatter(responseItem.def, responseItem.value)}
            </td>
        </tr>
    ) : null;
};
export const ThresholdMetrics = ({ timeslice, degradedKey, excesiveKey }) => {
    const classes = useTooltipStyles();
    const degradedClass = timeslice.status === 'yellow' ? classes.thresholdDegraded : classes.thresholdNormal;
    const excessiveClass = timeslice.status === 'orange' ? classes.thresholdExcessive : classes.thresholdNormal;
    const { testThresholds } = timeslice.chartDef;
    let excessiveItem = testThresholds?.excessive;
    let degradedItem = testThresholds?.degraded;
    timeslice.items.forEach((item) => {
        const { key } = item.def;

        if (key === degradedKey) degradedItem = item;
        if (key === excesiveKey) excessiveItem = item;
    });
    return (
        <table className={classes.tooltipTable} style={{ paddingTop: '10px' }}>
            <tbody>
                <tr className={clsx(classes.thresholdTooltipPoint, degradedClass)}>
                    <td className={classes.thresholdTooltipPointLabel}>Degraded Threshold:</td>
                    <td className={classes.tooltipPointValue}>
                        {chartDefFormatter(degradedItem?.def, degradedItem?.value)}
                    </td>
                </tr>
                <tr className={clsx(classes.thresholdTooltipPoint, excessiveClass)}>
                    <td className={classes.thresholdTooltipPointLabel}>Excessive Threshold:</td>
                    <td className={classes.tooltipPointValue}>
                        {chartDefFormatter(excessiveItem?.def, excessiveItem?.value)}
                    </td>
                </tr>
            </tbody>
        </table>
    );
};
